import React from 'react'
import ServiceLayout from 'components/ServiceLayout'

const BLOCKS = [
  {
    title: 'Estratégia de Mídia',
    desc: 'O plano de canais e verba orientado ao seu objetivo de negócio.',
    items: [
      'Segmentação de personalizada de público',
      'Estruturação de canais e plataformas',
      'Definição de funil de campanhas',
      'Indicadores de desempenho',
    ],
  },
  {
    title: 'Criação de Campanhas',
    desc: 'Google Ads e Meta Ads criados para atrair a atenção certa.',
    items: [
      'Gestão de Meta Ads (Instagram e Facebook)',
      'Criação de campanhas Google Ads',
      'Criativos orientados a conversão',
      'Reels de alta performance',
    ],
  },
  {
    title: 'Otimização Contínua',
    desc: 'Cada real investido analisado e ajustado para gerar mais retorno.',
    items: [
      'Otimização contínua de campanhas',
      'Testes A/B de criativos e públicos',
      'Relatórios de performance e ROI',
      'Gestão de relacionamento com o cliente (CRM)',
    ],
  },
]

const STEPS = [
  { title: 'Diagnóstico', desc: 'Avaliamos histórico de campanhas, público e concorrência.' },
  { title: 'Estruturação', desc: 'Montamos a arquitetura de campanhas e o funil de conversão.' },
  { title: 'Veiculação', desc: 'Colocamos as campanhas no ar com monitoramento diário.' },
  { title: 'Otimização', desc: 'Ajustamos públicos, criativos e orçamento com base em dados.' },
]

function ServicePaidTraffic() {
  return (
    <ServiceLayout
      pageTitle='Agência Dorac - Tráfego Pago'
      eyebrow='Tráfego Pago'
      title='Campanhas que atraem, convertem e fidelizam'
      subtitle='Atraímos, convertemos e fidelizamos clientes através de campanhas orientadas a dados e estratégias personalizadas.'
      intro='Tráfego pago sem estratégia é dinheiro queimado. Por isso cada campanha começa com a leitura do comportamento do seu público-alvo: o que atrai a atenção dele, o que gera confiança e o que finalmente faz a conversão acontecer. Depois, é teste, métricas e otimização constante.'
      blocks={BLOCKS}
      steps={STEPS}
      ctaText='Quero mais leads qualificados'
    />
  )
}

export default ServicePaidTraffic
